import { Box, CircularProgress, Grid, Typography, Zoom } from "@mui/material"
import React, { useContext } from "react"
import city from "../../../../assets/img/empty-result-city.png"
import { customPalette } from "../../../../theme"
import { ProjectListContext } from "../../../core/context/project/ProjectListContext"
import { ProjectCardDto } from "../../../core/dto/project/ProjectCardDto"
import { ProjectCard } from "./ProjectCard"

export function ProjectList(): React.JSX.Element {
  const { projectList, isLoading } = useContext(ProjectListContext)

  return (
    <Grid container item xs={12}>
      {!isLoading && (
        <Grid container columnSpacing={4} alignItems="flex-start" rowGap={3}>
          {projectList.length > 0 ? (
            projectList.map((project: ProjectCardDto, index) => (
              <Zoom in style={{ transitionDelay: `${index * 150}ms` }} key={project.id}>
                <Grid item xs={12} md={4} lg={4} key={project.id}>
                  <ProjectCard projectCardInfo={project} hasCoverImage={false} />
                </Grid>
              </Zoom>
            ))
          ) : (
            <Grid container item xs={12} flexDirection="column" height="100%" alignItems="center" justifyContent="center">
              <Typography
                fontSize="24px"
                fontWeight={600}
                lineHeight="36px"
                textAlign="center"
                color={customPalette.darkBlue3}>
                Aucun résultat
              </Typography>
              <Typography variant="body1">Modifier les options de recherche.</Typography>
              <Box sx={{ p: 2 }}>
                <img
                  src={city}
                  alt={city}
                  height="300px"
                  width="max-content"
                  style={{
                    marginLeft: 15,
                    marginTop: -8,
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      )}

      {isLoading && (
        <Grid container item xs={12} height="100%" alignItems="center" justifyContent="center">
          <CircularProgress />
        </Grid>
      )}
    </Grid>
  )
}
